<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title">
            会話シナリオ編集
          </p>
        </header>
        <div class="card-content" v-if="isSelect">
          <!-- メッセージ送るシナリオ -->
          <div class="message" v-if="scenarioEdit.status===0 || scenarioEdit.status===2 || scenarioEdit.status===6">
            <div class="columns is-multiline is-mobile">
              <div class="column" style="margin-right: 5px; background-color:white;">
                <p>メッセージ内容</p>
                <p style="font-size: 13px; padding:10px;">
                  <b-field>
                    <b-input type="textarea" placeholder="例：お名前を入力してください" v-model="scenarioEdit.mainmessage"></b-input>
                  </b-field>
                </p>
                <p v-if="scenarioEdit.status===0">選択肢</p>
                <p style="font-size: 13px; padding:10px; padding-left:20px;" v-for="(s, scnIDX) in scenarioEdit.select" :key="scnIDX" v-if="scenarioEdit.status===0">
                  <b-field>
                    <b-input placeholder="ボタン選択肢を入力" v-model="s.message" expanded></b-input>
                    <b-select placeholder="色" v-model="s.text_option">
                      <option v-for="(color, colorNum) in buttonColors" :key="colorNum">
                        {{color}}
                      </option>
                    </b-select>
                    <button class="button" style="background: #f8f8f8;" @click="delSelect(scnIDX)"><span class="mdi mdi-close"></span></button>
                  </b-field>
                </p>
                <p style="font-size: 13px; padding:10px;" v-if="scenarioEdit.select.length < 6 && scenarioEdit.status===0">
                  <button class="button is-fullwidth" @click="addSelect()">ボタン追加</button>
                </p>
              </div>
            </div>
          </div>
          <!-- 応募フォームシナリオ -->
          <div class="message" v-if="scenarioEdit.status===1">
            <b-message type="is-primary" has-icon>
              応募フォームは変更することができません。
            </b-message>
          </div>
          <div class="message" v-if="scenarioEdit.status===8">
            <b-message type="is-primary" has-icon>
              履歴書フォームは変更することができません。
            </b-message>
          </div>
          <div class="message" v-if="scenarioEdit.status===3">
            <div class="columns is-multiline is-mobile">
              <div class="column" style="margin-right: 5px; background-color:white;">
                <p style="padding: 10px;"><b>切り替えを行うロボを選択してください</b></p>
                <div style="justify-content: center; display: flex;">
                  <img class="img-icon" :src="cb.icon_data" v-if="cb.icon_data">
                  <img class="img-icon" src="@/assets/template/robot.png" v-else>
                </div>
                <div style="font-size: 13px; padding:10px; justify-content: center; display: flex;">
                  <b-field style="max-width: 100%;">
                    <b-select placeholder="ロボ名" v-model="scenarioEdit.mainmessage">
                      <option v-for="(n, index) in chatbots" :key="index">
                        {{n.name}}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
          <!-- カレンダー連携 -->
          <div class="message" v-if="scenarioEdit.status===4">
            <div class="columns is-multiline is-mobile">
              <div class="column" style="margin-right: 5px; background-color: white;">
                <p class="padding: 10px;"><b>タイトル</b></p>
                <div style="font-size: 13px; padding: 10px; justify-content: center; display: flex;">
                  <b-input placeholder="タイトルを入力" v-model="parameter.title" max-length="100"></b-input>
                </div>
                <p class="padding: 10px;"><b>参加メンバー</b></p>
                <div style="font-size: 13px; padding: 10px; justify-content: center; display: flex; flex-wrap:wrap;">
                  <b-checkbox v-for="(u, idx) in users" :key="idx" v-model="parameter.user_hash" style="margin: 5px;"
                      :native-value="u.user_hash">
                      {{u.username}}
                  </b-checkbox>
                </div>
                <p class="padding: 10px;"><b>設定しない曜日</b></p>
                <div style="font-size: 13px; padding: 10px; justify-content: center; display: flex;">
                  <b-checkbox v-for="(ch, idx) in weekdayList" :key="idx" v-model="parameter.holiday_list"
                      :native-value="idx">
                      {{ch}}
                  </b-checkbox>
                </div>
                <p class="padding: 10px;"><b>調整可能日時</b></p>
                <div style="font-size: 13px; padding: 10px; justify-content: center; display: flex; align-items: center;">
                  <b-timepicker v-model="start" size="is-small" inline></b-timepicker>
                  <p style="font-size: 24px;margin-left:10px;margin-right:10px;"><b>-</b></p>
                  <b-timepicker v-model="end" size="is-small" inline></b-timepicker>
                </div>
              </div>
            </div>
          </div>
          <!-- 画像表示 -->
          <div v-if="scenarioEdit.status===5">
            <div style="width: 302px; height: 202px; background: white; border: dashed thin #323; margin-left: 25%;">
              <b-tooltip label="クリックもしくはドラッグ＆ドロップで画像をアップロードします。">
                <croppa
                  v-model="croppa" 
                  placeholder="画像のアップロードする"
                  canvas-color="transparent"
                  :width="300"
                  :height="200"
                  :file-size-limit="2097152"
                  remove-button-color="black"
                  accept=".jpeg,.png,.gif,.svg,.bmp,.jpg"
                  :show-loading="true"
                  @file-type-mismatch="onFileTypeMismatch"
                  @file-size-exceed="onFileSizeExceed">
                </croppa>
              </b-tooltip>
            </div>
            <a class="button button-img" style="margin-top:5px;" @click="croppa.chooseFile()">
              <span class="mdi mdi-image" style="margin-right: 10px;"></span>画像のアップロードする
            </a>
          </div>
          <!-- ファイルアップロード -->
          <div class="message" v-if="scenarioEdit.status===7">
            <div class="columns is-multiline is-mobile">
              <div class="column" style="margin-right: 5px; background-color: white;">
                <p>ファイルがアップロードされます</p>
              </div>
            </div>
          </div>
          <hr>
          <button class="button is-primary is-fullwidth" @click="clickSaveScenario()" v-if="scenarioEdit.status!==1&&scenarioEdit.status!==5&&scenarioEdit.status!==8" :disabled="scenarioEdit.status===4&&(parameter.user_hash.length<1||this.start.getHours()>this.end.getHours())">
            会話シナリオ変更
          </button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalEditScenario',
  data () {
    return {
      isCardModalActive: false,
      isSelect: true,
      isMessage: false,
      cb: {
        icon: ''
      },
      scenarioName: 'default',
      scenarioEdit: {
        mainmessage: 'default',
        status: 0,
        select: [{
          message: 'default',
          text_option: 'default',
          point: 0
        }],
        parameter: {}
      },
      buttonColors: [
        'White',
        'Blue',
        'Yellow',
        'Red'
      ],
      selectedUser: null,
      start: new Date(2000, 1, 1, 9, 0),
      end: new Date(2000, 1, 1, 18, 0),
      timeList: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
      ],
      weekdayList: [
        '月', '火', '水', '木', '金', '土', '日'
      ],
      weekdayModel: [],
      parameter: {
        title: '',
        user_hash: [],
        holiday_list: [],
        work_time_start: 9,
        work_time_end: 18,
        interval: 0,
        mtg_time: 1,
        count: 5,
        after: 1,
        until: 30
      },
      croppa: null
    }
  },
  computed: {
    ...mapState('auth', ['user', 'users']),
    ...mapState('chatbot', ['selectScenario', 'scenarioTable', 'modalScenario', 'isModalEditScenario', 'chatbots', 'isRoboPartsSetView']),
    ...mapState('calendar', ['recommendDate'])
  },
  mounted () {
    console.debug('*** Start *** mounted')
    this.scenarioEdit = this.modalScenario
    if (this.scenarioEdit.status === 6) this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[input]', '').replace('[/input]', '')
    if (this.modalScenario.parameter) this.parameter = this.modalScenario.parameter
    console.debug('*** End *** mounted')
  },
  watch: {
    isModalEditScenario () {
      this.isCardModalActive = this.isModalEditScenario
    },
    modalScenario () {
      this.scenarioEdit = this.modalScenario
      if (this.scenarioEdit.status === 6) this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[input]', '').replace('[/input]', '')
      if (this.modalScenario.parameter) this.parameter = this.modalScenario.parameter
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    },
    'scenarioEdit.mainmessage' () {
      for (var i in this.chatbots) {
        if (this.chatbots[i].name === this.scenarioEdit.mainmessage) this.cb = this.chatbots[i]
      }
    }
  },
  methods: {
    onFileTypeMismatch (file) {
      console.debug('*** Start *** onFileTypeMismatch')
      console.debug('file: ' + JSON.stringify(file))
      alert('jpg, gif, png, svg　形式でアップして下さい。')
      console.debug('*** End *** onFileTypeMismatch')
    },
    onFileSizeExceed (file) {
      console.debug('*** Start *** onFileSizeExceed')
      console.debug('file: ' + JSON.stringify(file))
      alert('ファイルは2MB以下でアップロードして下さい。')
      console.debug('*** End *** onFileSizeExceed')
    },
    saveImage (data) {
      console.debug('*** Start *** saveImage')
      console.debug('data: ' + JSON.stringify(data))
      if (this.isRoboPartsSetView) {
        var scenarioData = {
          image: data.replace(/^.*,/, ''),
          scenario: this.scenarioEdit,
          template_id: this.selectTemplateId
        }
      }
      else {
        var scenarioData = {
          image: data.replace(/^.*,/, ''),
          scenario: this.scenarioEdit,
          template_id: ''
        }
      }
      this.$store.dispatch('chatbot/setScenarioImage', scenarioData)
      console.debug('*** End *** saveImage')
    },
    onFileChange (e) {
      console.debug('*** Start *** onFileChange')
      console.error('e: ' + JSON.stringify(e))
      let files = e.target.files || e.dataTransfer.files
      this.filename = files[0].name
      let reader = new FileReader()
      reader.onload = (e) => {
        if (this.isRoboPartsSetView) {
          var scenarioData = {
            image: data.replace(/^.*,/, ''),
            scenario: this.scenarioEdit,
            template_id: this.selectTemplateId
          }
        }
        else {
          var scenarioData = {
            image: data.replace(/^.*,/, ''),
            scenario: this.scenarioEdit,
            template_id: ''
          }
        }
        this.$store.dispatch('chatbot/setScenarioImage', scenarioData)
      }
      reader.readAsDataURL(files[0])
      console.debug('*** End *** onFileChange')
    },
    clickSaveScenario () {
      console.debug('*** Start *** clickSaveScenario')
      console.log('clickSaveScenario: ' + this.user.companyID)
      console.log('CHECK USER HASH' + JSON.stringify(this.user))
      // messageのみの場合は不要なselect, msgtype, templateを削除する
      this.scenarioEdit = this.modalScenario
      console.log('CHECK SCENARIOEDIT' + JSON.stringify(this.scenarioEdit))
      if (this.scenarioEdit.status === 4) {
        console.info('scenarioEdit.status is 4')
        var start_hour = this.start.getHours()
        var start_minute = this.start.getMinutes()
        var end_hour = this.end.getHours()
        var end_minute = this.end.getMinutes()
        this.Parameter.work_time_start = parseFroat(start_hour + (start_minute / 100))
        this.Parameter.work_time_end = parseFroat(end_hour + (end_minute / 100))
        this.parameter['company_hash'] = this.user.companyID
        this.scenarioEdit.parameter = this.parameter
      } else if (this.scenarioEdit.status === 6) {
        console.info('scenarioEdit.status is 6')
        if (this.scenarioEdit.mainmessage.indexOf('[input][/input]') > -1) this.scenarioEdit.mainmessage += '[input][/input]'
      } else if (this.scenarioEdit.status === 3) {
        console.info('scenarioEdit.status is 3')
        this.scenarioEdit.select = [{
          'message': '',
          'msg_type': '',
          'text_option': '',
          'next_node': this.cb.scenario_name
        }]
      } else if (this.scenarioEdit.status === 5) {
        console.info('scenarioEdit.status is 5')        
      }
      else if (this.scenarioEdit.select[0].message === '') {
        console.info('scenarioEdit.select[0].message is blank')
        var temp = this.scenarioEdit.select[0].next_node
        this.scenarioEdit.select = [{
          'message': '',
          'msg_type': '',
          'text_option': '',
          'next_node': temp
        }]
        this.scenarioEdit.status = 2
      } else {
        console.info('else')
        // this.scenarioEdit.status = this.scenario.status
        for (var i in this.scenarioEdit.select) {
          this.scenarioEdit.select[i].msg_type = 'button'
          if (this.scenarioEdit.select[i].text_option === '') this.scenarioEdit.select[i].text_option = 'white'
        }
      }
      console.log('CHECK SCENARIO EDIT' + JSON.stringify(this.scenarioEdit))
      this.$store.dispatch('chatbot/setScenarioDemo', this.scenarioEdit)
      this.$store.dispatch('chatbot/closeModalScenario')
      this.isCardModalActive = false
      console.debug('*** End *** clickSaveScenario')
    },
    addSelect () {
      console.debug('*** Start *** addSelect')
      var s = {
        'message': '',
        'msg_type': 'button',
        'text_option': 'white',
        'next_node': ''
      }
      this.scenarioEdit.select.push(s)
      console.debug('*** End *** addSelect')
    },
    delSelect (idx) {
      console.debug('*** Start *** delSelect')
      console.debug('idx: ' + JSON.stringify(idx))
      this.scenarioEdit.select.splice(idx, 1)
      console.debug('*** End *** delSelect')
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 22px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.img-icon {
  display:    block;
  min-width:  200px;
  min-height: 200px;
  width:      200px;
  height:     200px;
  max-width:  200px;
  max-height: 200px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
}
.img-icon-sq {
  display:    block;
  min-width:  300px;
  min-height: 250px;
  width:      300px;
  height:     250px;
  max-width:  300px;
  max-height: 250px;
  border-radius: 5px;
  object-fit: cover;
  border: solid thin #ccc;
}
/* Image Upload UI */
.upload-form {
  position: relative;
}
.upload-style {
  width: 100px;
  border-radius: 10px;
  text-decoration: none;
}
.upload-style > input {
  display: none;
}
.button-img {
  width: 300px;
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Top/ModalEditScenarioDemo.vue